import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { GENERAL_ERROR_MESSAGE } from '../../../../../i18n/keyConstants';

const AlertModal = (props) => {
    const { onHide, content, show } = props;
    const { t } = useTranslation(['errorMessages']);

    return (
        <Modal show={show} onHide={onHide} size='sm' centered>
            <Modal.Body>{content ? content : t(GENERAL_ERROR_MESSAGE)}</Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={onHide}>
                    Stäng
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AlertModal;
